export default "__VITE_ASSET__4e4fa2cb__"